module.exports = __webpack_public_path__ + "static/media/watermark-left-preview.983dd957.png";